module.exports = __webpack_public_path__ + "static/img/img-promo-bolt-pre-pays-option.dfd1c47.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img-promo-bolt-pre-pays-option.svg
// module id = 1860
// module chunks = 1